import React, {ReactNode} from 'react';
import classnames from 'classnames';
import FormButton from 'src/components/button';
import Icon from 'shared/components/icon';
import browserHistory from '../../history';
import {Link} from 'react-router-dom';
import {useMediaQuery} from 'src/hooks/useMediaQuery';

interface Props {
  addNew?: (options?: {scrollTo?: boolean}) => void;
  children: ReactNode;
  title: string;
  displayNew: boolean;
  sectionName: string;
  extraComponent?: ReactNode;
  showAddCourseButton?: boolean;
  viewImportReportCard?: boolean;
}

const PortfolioSectionHeader = ({
  addNew,
  children,
  title,
  displayNew,
  sectionName,
  extraComponent,
  showAddCourseButton,
  viewImportReportCard,
}: Props) => {
  const handleClick = () => {
    addNew?.({scrollTo: true});
  };

  const mq = useMediaQuery();

  const buttonName = `portfolio ${sectionName} section-header add`;
  const legendText = `Add ${title}`;

  const displayedComponents = mq.XS ? (
    <Icon
      className="portfolio-section-header-icon"
      iconType="plus"
      onClick={addNew}
      buttonName={buttonName}
      role="button"
      aria-label={legendText}
      aria-hidden="false"
    />
  ) : (
    <FormButton
      color="blue"
      link
      onClick={handleClick}
      margin={false}
      aria-label={legendText}
      buttonName={buttonName}
    >
      Add <Icon className="portfolio-section-header-new-button" iconType="plus-r"></Icon>
    </FormButton>
  );

  return (
    <>
      <div
        className={classnames(
          'portfolio-section-header prefix-flex prefix-align-items',
          sectionName
        )}
      >
        {children}
        <span className="portfolio-section-header-title prefix-flex prefix-flex-grow-1">
          {title}
        </span>
        {extraComponent}
        {displayNew && displayedComponents}
        {showAddCourseButton ? (
          <FormButton
            outline
            margin={false}
            onClick={() => {
              browserHistory.replace(`${location.pathname}/course/new`);
            }}
          >
            + Add course
          </FormButton>
        ) : (
          ''
        )}
      </div>
      {viewImportReportCard && (
        <div className="align-right mb-20">
          <Link to="/import-report-card" className="shared-button small blue">
            <Icon iconType="arrow-alt-from-bottom pr-10" className="icon-position" />
            <p className="inline">Import Report Card</p>
          </Link>
        </div>
      )}
    </>
  );
};

export default PortfolioSectionHeader;
